import { Component, VERSION } from '@angular/core';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEventType } from '@angular/common/http';

import { Injectable } from '@angular/core';
// import { sgUsuario } from '@modelos/auth/user';
import { Observable } from 'rxjs';
import { apiMainService } from '../api.main.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})


export class FilesService extends apiMainService {

  public percentDone: number;
  public uploadSuccess: boolean;

  // version = VERSION

  // upload(data) {

  //   console.log('dataArchivo',data)

  //   this.httpOptions.headers.append('X-Requested-With', 'XMLHttpRequest');


  //   return this.http.post(this.url_api + '/fileuploade/',data, { headers: this.httpOptions.headers,  withCredentials: true }).subscribe(
  //     {

  //       next : (data) =>{
  //         console.log(data)
  //       },

  //       error : (err) => {console.log(err)}
        
  //     }
  //   )

  //   // this.http.post(this.url_api + '/fileupload/?idproducto=159' , data, { reportProgress: true, observe: 'events' })

	// 	// return this.http.post(environment.serverURL + "api/incidencia/guardar/archivo", data, options).pipe(
  //   //   map((res: Response) => res.json()))
      

	// }


  upload(files: File[],data : string ) {
    //pick from one of the 4 styles of file uploads below
    this.uploadAndProgress(files,data);
  }

  basicUpload(files: File[]) {
    var formData = new FormData();
    Array.from(files).forEach(f => formData.append('file', f))
    this.http.post(this.url_api + '/fileupload/', formData)
      .subscribe(event => {
        console.log('done')
      })
  }

  //this will fail since file.io dosen't accept this type of upload
  //but it is still possible to upload a file with this style
  basicUploadSingle(file: File) {
    this.http.post(this.url_api + '/fileupload/', file)
      .subscribe(event => {
        console.log('done')
      })
  }

  uploadAndProgress(files: File[], data : string ) : Observable<any>  {

    if (!files || files.length == 0) {      
      return;
    }

    var formData = new FormData();
    Array.from(files).forEach(f => formData.append('file', f))

    // this.http.post(this.url_api + '/fileupload/?idproducto=' + idproducto.toString(), formData, { reportProgress: true, observe: 'events' })
    return this.http.post('https://190.116.36.140:8080/fileupload/?nombreinicio='+ data, formData, { reportProgress: true, observe: 'events' })
      // .subscribe(
      //   {
      //     next: (event) => {            
      //       if (event.type === HttpEventType.UploadProgress) {
      //         this.percentDone = Math.round(100 * event.loaded / event.total);
      //       } else if (event instanceof HttpResponse) {
      //         this.uploadSuccess = true;
      //       }
      //     },

      //     error :(err) =>{
      //       console.log(err)
      //     }
          
      //   }

      // );

  }


  // uploadAndProgress(files: File[]){
  //   console.log(files)
  //   var formData = new FormData();
  //   Array.from(files).forEach(f => formData.append('file',f))

  //   let idproducto : number = 159;

  //   this.http.post(this.url_api + '/fileupload/?idproducto='+idproducto.toString() , formData, {reportProgress: true, observe: 'events'})
  //     .subscribe(event => {
  //       if (event.type === HttpEventType.UploadProgress) {
  //         this.percentDone = Math.round(100 * event.loaded / event.total);
  //       } else if (event instanceof HttpResponse) {
  //         this.uploadSuccess = true;
  //       }
  //   });

  // }

  //this will fail since file.io dosen't accept this type of upload
  //but it is still possible to upload a file with this style
  uploadAndProgressSingle(file: File) {

    this.http.post(this.url_api + '/fileupload/', file, { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          this.uploadSuccess = true;
        }
      });

  }

  //get Medida All
  // uploadFiles$(formData) {
  //   return this.http.post(this.url_api + '/fileupload/',formData, { headers: this.httpOptions.headers });
  // }
}
